<template>
  <div class="trainer-slider-actions tracoac text-noselect">
    <RangeInput
      class="f-column"
      :values="l_sliderActions"
      style="--rainput-height: 1em; --rainput-clr-back: var(--clr-black-2); gap: 0.25rem"
      :readOnly="hasResult"
      @values:update="({ values }) => handleInput(values)"
    >
      <template #before="{ methods, values }">
        <div
          v-if="loading"
          class="mx-auto"
          style="
            height: 1em;
            border-radius: 4px;
            background: var(--clr-black-2);
            width: clamp(1px, 24rem, 50%);
            margin-bottom: 0.5em;
          "
        ></div>
        <div
          v-else
          class="f-center"
          style="gap: 1em; margin-bottom: 0.25em"
        >
          <div
            v-for="(action, aIdx) in values"
            :key="`${aIdx}`"
            class="f-center"
            style="gap: 0.5em"
          >
            <div
              class="weight_700 rab_btn_name f-center"
              :style="`color:${action.hex}`"
            >
              {{ action.display_name || $t(`browse.${action.group_display_name}`) }}

              <div
                v-if="hasResult"
                style="padding: 0 0 0 0.5em"
              >
                {{ numFixed(action.frequency * 100) }}%
              </div>
            </div>
            <div
              v-if="!hasResult"
              class="csst"
              @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: 'top' })"
            >
              <NumberInput
                class="z-index_2 numinput_white"
                :value="numFixed(action.percentage * 100)"
                :min="0"
                :max="100"
                :step="1"
                :hasMinus="false"
                :hasPlus="false"
                style="--input-height: 1.5em"
                @input="num => methods.handleInput(num / 100, aIdx, true)"
              />
              <GwBtns
                :options="presets"
                style="position: fixed; --gwbtn-padding: 0 0.25rem; padding: 0.25rem"
                class="csst_content csst_content_hoverable gwbtns_horizontal_grey"
                @click="(_e, item) => methods.handleInput(item, aIdx, true)"
              >
                <template #default="{ item }">
                  {{ item * 100 }}
                </template>
              </GwBtns>
            </div>
          </div>
        </div>
      </template>
    </RangeInput>
    <!-- @values:update="({ values }) => handleInput(values)" -->
  </div>
</template>

<script>
import NumberInput from '@/components/lib/NumberInput'
import RangeInput from '@/components/lib/RangeInput'
import GwBtns from '@/components/lib/GwBtns'
import { balanceValues } from '@/helpers/helpers'

import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'TrainerSliderActions',
  components: {
    NumberInput,
    RangeInput,
    GwBtns,
  },
  mixins: [format_mix, float_mix],
  props: {
    actions: Array,
    sliderActions: Array,
    hasResult: Boolean,
    hasChart: Boolean,
    hasCheatFrequency: Boolean,
    selectKey: { default: 'is_selected' },
    loading: Boolean,
  },
  emits: ['update'],
  data() {
    this.presets = [0, 0.25, 0.5, 0.75, 1]
    return {}
  },
  methods: {
    handleNumInput(num, aIdx) {
      let res = [...this.l_sliderActions]
      res = res.map((i, idx) => {
        if (idx === aIdx) {
          i.frequency = num
          return i
        }
        return i
      })

      let frequencies = res.map(i => i.frequency)
      frequencies = balanceValues(frequencies, aIdx)

      res = res.map((i, idx) => ({
        ...i,
        frequency: frequencies[idx],
      }))
      this.handleInput(res)
    },
    handleInput(values) {
      let res = values.map((i, idx) => ({
        ...i,
        frequency: values[idx].percentage,
      }))

      const frequencies = res.map(i => i.frequency)
      const topFreq = Math.max(...frequencies)
      const topFreqIdx = frequencies.indexOf(topFreq)
      const topFreqAction = res[topFreqIdx]
      const action = (this.actions || []).find(a => a.code === topFreqAction?.code) || null
      res = res.map(i => ({ ...i, is_preselected: i.code === action.code }))

      this.$emit('update', { action, actions: res })
    },
  },
  computed: {
    l_sliderActions() {
      const res = (this.sliderActions || []).map(i => ({
        ...i,
        id: i.id || i.code,
        cssClass: i.css_class,
        name: i.display_name,
        percentage: i.frequency,
      }))
      return res
    },
    tra() {
      return this.$store.state.trainer
    },
  },
}
</script>
<style lang="scss" scoped>
.tracoac {
  display: flex;
  flex-direction: column;
  &_actions {
    position: relative;
  }
  &_slider {
    margin: 1rem 0 0 0;
    position: relative;
  }
}
</style>
